import React from "react";

import { Skeleton } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    maxHeight: "96px",
    backgroundColor: theme.palette.common.white,
  },
  skeleton: {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
    margin: theme.spacing(1),
  },
  status: {
    marginRight: theme.spacing(0),
    marginLeft: theme.spacing(2.5),
  },
}));

const ArrearsSkeleton: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Skeleton
        variant="text"
        width="100%"
        height={26}
        className={classes.skeleton}
      />
    </div>
  );
};

export default ArrearsSkeleton;
